import { MessageType } from '@/types/common';
import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';
import { Message } from '@/enums/message.enum';
import { MESSAGE } from '@/constants/message.constant';

type ConclusionRecommendationState = {
  loading: boolean;
  message?: MessageType;
  conclusionRecommendationList: ConclusionRecommendationList;
};

const initialState: ConclusionRecommendationState = {
  loading: false,
  conclusionRecommendationList: []
};

export const conclusionRecommendationSlice = createAppSlice({
  name: 'conclusion-recommendation',
  initialState,
  reducers: (create) => ({
    getConclusionRecommendation: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.post('conclusion/detail', query);
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.conclusionRecommendationList = transformerArray(
            action.payload.listData
          );
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    ),
    updateConclusionRecommendation: create.asyncThunk(
      async (data: { model: string; gender?: string; ageType?: string; items: string }) => {
        const response = await apiFetcher.post('conclusion/create', data);
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state) => {
          state.loading = false;
          state.message = {
            type: Message.SUCCESS,
            message: MESSAGE.UPDATE_SUCCESS
          };
        },
        rejected: (state) => {
          state.loading = false;
          state.message = {
            type: Message.ERROR,
            message: MESSAGE.UPDATE_FAIL
          };
        }
      }
    ),
    resetMessages: create.reducer((state) => {
      state.message = undefined;
    })
  }),

  selectors: {
    watchConclusionRecommendationLoading: (conclusionRecommendation) =>
      conclusionRecommendation.loading,
    watchConclusionRecommendationMessage: (conclusionRecommendation) =>
      conclusionRecommendation.message,
    watchConclusionRecommendationList: (conclusionRecommendation) =>
      conclusionRecommendation.conclusionRecommendationList
  }
});

export const {
  watchConclusionRecommendationLoading,
  watchConclusionRecommendationMessage,
  watchConclusionRecommendationList
} = conclusionRecommendationSlice.selectors;

export const {
  getConclusionRecommendation,
  updateConclusionRecommendation,
  resetMessages
} = conclusionRecommendationSlice.actions;
